import { createFileRoute } from "@tanstack/react-router";
import { CheckCircle2 } from "lucide-react";
import { HelmCompass } from "@/components/helm-logo";

export const Route = createFileRoute("/checkout/success")({
	component: CheckoutSuccessPage,
});

function CheckoutSuccessPage() {
	return (
		<div className="min-h-dvh flex flex-col items-center justify-center bg-background px-6">
			<div className="text-center space-y-8 max-w-md">
				{/* Helm logo */}
				<div className="flex items-center justify-center gap-3">
					<HelmCompass size={40} className="text-foreground" />
					<span className="text-2xl tracking-[0.3em] font-light text-foreground">
						H E L M
					</span>
				</div>

				<div className="w-16 h-px bg-primary mx-auto" />

				{/* Success icon */}
				<div className="flex items-center justify-center">
					<div className="h-20 w-20 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center animate-in zoom-in duration-500">
						<CheckCircle2 className="h-10 w-10 text-green-600 dark:text-green-400" />
					</div>
				</div>

				{/* Message */}
				<div className="space-y-3">
					<h1 className="text-3xl font-semibold text-foreground tracking-tight">
						Thank You
					</h1>
					<p className="text-muted-foreground text-lg">
						Your payment was successful. Welcome to Helm.
					</p>
					<p className="text-muted-foreground text-sm">
						Check your email for next steps to set up your campaign.
					</p>
				</div>
			</div>
		</div>
	);
}
